import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { ApiService } from '../services/api.service';
import { catchError } from 'rxjs/operators';
import {
  tap,
} from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
  token: any;
  constructor(private authService: AuthService, private apiService: ApiService) { }
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

  const token = this.authService.getToken();

  // Check if the URL is in the blocked list and clone the request if token should be added
  let request = httpRequest;
  if (!this.isInBlockedList(httpRequest.url)) {
    if (token) {
      request = httpRequest.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    } else {
    }
  }

  return next.handle(request).pipe(
    catchError((error: HttpErrorResponse) => {
      // Check if the error is a 401
      if (error.status === 401) {
        // If the request URL is for login, let the component handle the error
        if (this.isLoginRequest(httpRequest.url)) {
          return throwError(() => error);  // Pass the error back to the login component
        } else {
          // Handle 401 errors for other endpoints by logging out
          this.handle401Error();
        }
      }
      return throwError(() => error);  // Pass other errors back to the caller
    })
  );
}

// Block list function to prevent token from being added to certain endpoints
private isInBlockedList(url: string): boolean {
  const blockedUrls = ['/register', '/verification/validate', '/login', '/validate/otp'];
  return blockedUrls.some(blockedUrl => url.includes(blockedUrl));
}

// Check if the URL is specifically for login
private isLoginRequest(url: string): boolean {
  return url.includes('/login');
}

// 401 error handling function to log out the user
private handle401Error() {
  this.apiService.logout();
}

}
